<template>
  <h4
    v-if="title"
    :class="$style.title"
  >
    {{ $t(title) }}
  </h4>
  <p
    v-if="text"
    :class="$style.text"
  >
    {{ $t(text) }}
  </p>
</template>

<script setup>

defineProps({
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss" module>
.title {
  color: $color-primary;
  @include H4;
  text-align: center;
}

.text {
  color: $color-primary;
  margin-top: 12px;
  @include base-text;
  text-align: center;
}
</style>
